// extracted by mini-css-extract-plugin
export var carrierIcon = "_tt-0";
export var carrierLogo = "_tt-1";
export var detailsSection = "_tt-2";